import { render } from "./profileHeader.vue?vue&type=template&id=ee266364"
import script from "./profileHeader.vue?vue&type=script&lang=js"
export * from "./profileHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__